import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-amber-100 rounded-full blur-3xl opacity-30"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-30"></div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-50 rounded-full border border-amber-200">
              <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></span>
              <span className="text-sm font-medium text-amber-800">Serving Jackson, TN</span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
              Your PC Built
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-orange-600">
                The Right Way
              </span>
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              Professional PC building, repairs, and support from a local expert you can trust. 
              Quality workmanship, honest advice, and attention to detail in every build.
            </p>

            {/* Key Benefits */}
            <div className="space-y-3">
              {[
                'Standard builds starting at $165',
                'Same-day diagnostics available',
                'Local pickup & delivery service'
              ].map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-amber-600 flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{benefit}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-6 text-lg font-semibold group"
              >
                Contact Me
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={() => scrollToSection('services')}
                variant="outline"
                className="border-2 border-gray-300 hover:border-amber-600 hover:text-amber-600 px-8 py-6 text-lg font-semibold"
              >
                View Services
              </Button>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative lg:h-[600px] hidden lg:block">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl transform rotate-3"></div>
            <div className="absolute inset-0 bg-white rounded-3xl shadow-2xl transform -rotate-3 flex items-center justify-center overflow-hidden">
              <div className="w-full h-full flex items-center justify-center p-12">
                <div className="grid grid-cols-2 gap-6 w-full">
                  {[
                    { label: 'Professional', icon: '⚡' },
                    { label: 'Reliable', icon: '🛡️' },
                    { label: 'Local', icon: '📍' },
                    { label: 'Expert', icon: '🔧' }
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 flex flex-col items-center justify-center gap-4 hover:scale-105 transition-transform"
                      style={{ animationDelay: `${index * 100}ms` }}
                    >
                      <div className="text-5xl">{item.icon}</div>
                      <div className="text-lg font-semibold text-gray-800">{item.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};